import { render, staticRenderFns } from "./BigCtaSection.vue?vue&type=template&id=48b87a26&scoped=true&"
import script from "./BigCtaSection.vue?vue&type=script&lang=js&"
export * from "./BigCtaSection.vue?vue&type=script&lang=js&"
import style0 from "./BigCtaSection.vue?vue&type=style&index=0&id=48b87a26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b87a26",
  null
  
)

export default component.exports